import { CommonLaboratoryDatasource } from '@/shared/resources/datasources/common/common-laboratory-datasource'
import { ShipmentItemResponse } from '@/modules/shipments-module/services/shipments.dto'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { AgColumnDefinition, IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { shipmentsItemFinderService } from '@/modules/shipments-module/services/item/item-finder/shipments-item-finder.service'
import { shipmentsGridPendingToReceiveColumnDefs } from '@/modules/shipments-module/components/grid/column-defs/shipments-grid-pending-to-receive.column-defs'

export class ShipmentsGridPendingToReceiveDatasource extends CommonLaboratoryDatasource<ShipmentItemResponse> {
    protected fetchData(filterModel: CommonFilterModel, params: CommonParams): Promise<IResponseAgGrid<ShipmentItemResponse>> {
        return shipmentsItemFinderService.findPendingToBeReceived(this.laboratoryId, filterModel, params)
    }

    public getColumnDefs(): AgColumnDefinition[] {
        return shipmentsGridPendingToReceiveColumnDefs
    }
}
